import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSearchContext } from '../contexts/SearchContext';

export const useSearchNavigation = () => {
  const navigate = useNavigate();
  const { pathname, search, state } = useLocation();
  const { handleClear } = useSearchContext();

  const isSportsRoute = pathname.startsWith('/sports') || pathname.startsWith('/in-play');
  const isOnSearchPage = pathname.startsWith('/search');
  const searchPath = isSportsRoute ? '/search?product=sportsbook' : '/search';
  const returnTo = typeof state?.searchReturnTo === 'string' ? state.searchReturnTo : undefined;
  const fallbackPath = new URLSearchParams(search).get('product') === 'sportsbook' ? '/sports' : '/casino';

  const closeSearch = useCallback(() => {
    handleClear();
    navigate(returnTo ?? fallbackPath);
  }, [fallbackPath, navigate, handleClear, returnTo]);

  const handleSearchClick = useCallback(() => {
    if (isOnSearchPage) {
      closeSearch();
    } else {
      navigate(searchPath, { state: { searchReturnTo: `${pathname}${search}` } });
    }
  }, [closeSearch, isOnSearchPage, navigate, pathname, search, searchPath]);

  return {
    handleSearchClick,
    closeSearch,
  };
};
